import React, { useEffect } from 'react';
import { OverlayAbsolute } from '/imports/ui/OverlayAbsolute';
import { BreadCrumb, setBreadcrumbs } from '/imports/ui/BreadCrumbs';

interface PageProps {
  className?: string,
  children: React.ReactNode,
  breadcrumbs?: BreadCrumb[],
  disabled?: boolean,
}

export const Page = (props: PageProps) => {
  useEffect(() => {
    if (props.breadcrumbs) setBreadcrumbs?.(props.breadcrumbs);
    else setBreadcrumbs?.([]);
  }, []);
  return (
    <div
      id="page"
      className={`page relative flex min-h-0 flex-1 flex-col overflow-auto print:w-full! mobile:w-full${props.className ? ` ${props.className}` : ''}`}
    >
      {props.children}
      {props.disabled && <OverlayAbsolute />}
    </div>
  );
};
